var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06675 16.2833L13.6751 11.6667C13.9834 11.3583 14.1584 10.9333 14.1584 10.4917V2.16667C14.1584 1.25 13.4084 0.5 12.4917 0.5H5.00008C4.33341 0.5 3.73341 0.9 3.47508 1.50833L0.758412 7.85C0.050079 9.5 1.25841 11.3333 3.05008 11.3333H7.75841L6.96675 15.15C6.88341 15.5667 7.00841 15.9917 7.30841 16.2917C7.80008 16.775 8.58341 16.775 9.06675 16.2833ZM17.5001 0.5C16.5834 0.5 15.8334 1.25 15.8334 2.16667V8.83333C15.8334 9.75 16.5834 10.5 17.5001 10.5C18.4167 10.5 19.1667 9.75 19.1667 8.83333V2.16667C19.1667 1.25 18.4167 0.5 17.5001 0.5Z",
    fill: "#B00020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDislike);
export default __webpack_public_path__ + "static/media/red_dislike.5934d3afc46dc436f10b09cae9242f22.svg";
export { ForwardRef as ReactComponent };